'use strict';

bbw.constraints = {

    AdminLogin: {
        email: {
            required: {
                message: 'Укажите ваш e-mail'
            },
            email: {
                message: 'Некорректный e-mail'
            },
            size: {
                max: 254
            }
        },
        password: {
            required: {
                message: 'Введите пароль'
            }
        }
    },

    SettingsNickname: {
        nickname: {
            required: {
                message: 'Укажите ваш ник'
            },
            size: {
                max: 25
            }
        }
    },

    SettingsGeo: {
        location: {
            required: {
                message: 'Выберите ваш город'
            }
        }
    },

    SettingsEmail: {
        email: {
            required: {
                message: 'Укажите ваш e-mail'
            },
            email: {
                message: 'Некорректный e-mail'
            },
            size: {
                max: 254
            }
        },
        email_exists: {
            max: {
                value: 0,
                message: 'Такой e-mail уже зарегистрирован'
            }
        },
        password: {
            required: {
                message: 'Введите пароль'
            }
        },
        password_mismatch: {
            max: {
                value: 0,
                message: 'Неверный пароль'
            }
        }
    },

    SettingsDelete: {
        password: {
            required: {
                message: 'Введите текущий пароль'
            }
        },
        password_mismatch: {
            max: {
                value: 0,
                message: 'Неверный пароль'
            }
        }
    },

    SettingsPassword: {
        password: {
            required: {
                message: 'Введите текущий пароль'
            }
        },
        password_mismatch: {
            max: {
                value: 0,
                message: 'Неверный пароль'
            }
        },
        new_password: {
            required: {
                message: 'Введите новый пароль'
            },
            size: {
                min: 5,
                message: 'Пароль слишком короткий'
            }
        }
    },

    PasswordResetRequest: {
        email: {
            required: {
                message: 'Укажите ваш e-mail'
            },
            email: {
                message: 'Некорректный e-mail'
            },
            size: {
                max: 254
            }
        },
        email_not_found: {
            max: {
                value: 0,
                message: 'Такой e-mail не зарегистрирован'
            }
        }
    },

    PasswordResetConfirm: {
        password: {
            required: {
                message: 'Введите пароль'
            },
            size: {
                min: 5,
                message: 'Пароль слишком короткий'
            }
        },
        password2: {
            required: {
                message: 'Повторите пароль'
            },
            same: {
                fieldName: 'password',
                message: 'Пароли не совпадают'
            }
        }
    },

    AdminPasswordResetConfirm: {
        password: {
            required: {
                message: 'Введите пароль'
            },
            size: {
                min: 5,
                message: 'Пароль слишком короткий'
            }
        },
        password2: {
            required: {
                message: 'Повторите пароль'
            },
            same: {
                fieldName: 'password',
                message: 'Пароли не совпадают'
            }
        },
        otp: {
            required: {
                message: 'Введите код'
            }
        }
    },

    UserProfile: {
        nickname: {
            required: {
                message: 'Укажите ваш ник'
            },
            size: {
                max: 25
            }
        },
        email: {
            required: {
                message: 'Укажите ваш e-mail'
            },
            email: {
                message: 'Некорректный e-mail'
            },
            size: {
                max: 254
            }
        },
        email_exists: {
            max: {
                value: 0,
                message: 'Такой e-mail уже зарегистрирован'
            }
        },
        sex: {
            required: {
                message: 'Выберите ваш пол'
            }
        },
        want_sex: {
            required: {
                message: 'Выберите, кого вы ищете'
            }
        },
        want_relations_m: {
            requiredWhen: {
                message: 'Выберите цель знакомства с парнем',
                fieldName: 'want_sex',
                when: function(fieldValue) {
                    return angular.isArray(fieldValue) && fieldValue.indexOf('a_want_sex_m') >= 0;
                }
            }
        },
        want_relations_f: {
            requiredWhen: {
                message: 'Выберите цель знакомства с девушкой',
                fieldName: 'want_sex',
                when: function(fieldValue) {
                    return angular.isArray(fieldValue) && fieldValue.indexOf('a_want_sex_f') >= 0;
                }
            }
        },
        password: {
            required: {
                message: 'Введите пароль'
            },
            size: {
                min: 5,
                message: 'Пароль слишком короткий'
            }
        },
        password2: {
            required: {
                message: 'Повторите пароль'
            },
            same: {
                fieldName: 'password',
                message: 'Пароли не совпадают'
            }
        },
        country: {
            required: {
                message: 'Выберите вашу страну'
            }
        },
        region: {
            required: {
                message: 'Выберите ваш регион'
            }
        },
        city: {
            required: {
                message: 'Выберите ваш город'
            }
        },
        birthdate: {
            required: {
                message: 'Укажите дату рождения'
            },
            dateIsValid: {
                message: 'Некорректная дата'
            },
            dateMinAge: {
                min: bbw.configuration.age.min,
                message: 'Разрешенный возраст: от ' + bbw.configuration.age.min + ' лет'
            },
            dateMaxAge: {
                max: bbw.configuration.age.max,
                message: 'Разрешенный возраст: до ' + bbw.configuration.age.max + ' лет'
            }
        }
    },

    AdminSettingsEmail: {
        email: {
            required: {
                message: 'Укажите ваш e-mail'
            },
            email: {
                message: 'Некорректный e-mail'
            },
            size: {
                max: 254
            }
        },
        password: {
            required: {
                message: 'Введите пароль'
            }
        },
        totp: {
            required: {
                message: 'Введите код'
            }
        }
    },

    AdminSettingsPassword: {
        new_password: {
            required: {
                message: 'Введите новый пароль'
            },
            size: {
                min: 5,
                message: 'Пароль слишком короткий'
            }
        },
        new_password2: {
            required: {
                message: 'Повторите новый пароль'
            },
            same: {
                fieldName: 'new_password',
                message: 'Пароли не совпадают'
            }
        },
        password: {
            required: {
                message: 'Введите пароль'
            }
        },
        totp: {
            required: {
                message: 'Введите код'
            }
        }
    },

    AdminSettingsTotp: {
        password: {
            required: {
                message: 'Введите пароль'
            }
        },
        totp: {
            required: {
                message: 'Введите код'
            }
        }
    }
};
